import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { type ComponentProps } from "react";

import { cn } from "../../utils/cn.util";
import { MenuItem, menuItemContent, type MenuItemContentProps, type MenuItemProps } from "../menu-item";

export type DropdownMenuItemProps = Omit<
  ComponentProps<typeof DropdownMenuPrimitive.Item>,
  "color" | "children" | "asChild"
> &
  Pick<MenuItemProps, "leading" | "color" | "shortcut" | "trailing" | "link"> &
  MenuItemContentProps & {
    inset?: boolean;
  };

export const Item = (props: DropdownMenuItemProps) => {
  const {
    leading,
    ref,
    className,
    inset,
    color,
    shortcut,
    trailing,
    label,
    description,
    link,
    children,
    ...itemProps
  } = props;

  return (
    <DropdownMenuPrimitive.Item ref={ref} {...itemProps} asChild>
      <MenuItem
        leading={leading}
        {...menuItemContent(label, description, children)}
        color={color}
        shortcut={shortcut}
        trailing={trailing}
        link={link}
        className={cn(inset && "pl-8", className)}
      />
    </DropdownMenuPrimitive.Item>
  );
};

Item.displayName = DropdownMenuPrimitive.Item.displayName;
